import styled from "styled-components";

export const HistoricoContainer = styled.div`
  margin-top: 1rem;

  display: flex;
  flex-direction: column;
`;

export const Table = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1.6fr 2.2fr;
  padding: 0;
  height: 36px;
  align-items: center;
  border-bottom: 1px solid var(--color-neutral-200);
`;

export const TableHeaderCell = styled.span`
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 150%;
  color: var(--color-text);
  text-align: left;
`;

export const TableRow = styled.div<{ $index: number }>`
  display: grid;
  grid-template-columns: 1.2fr 1.6fr 2.2fr;
  padding: 0;
  height: 40px;
  align-items: center;
  background-color: ${({ $index }) =>
    $index % 2 === 0 ? "var(--color-bg)" : "#F8F9F9"};
`;

export const TableCell = styled.span`
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  color: var(--color-text);
  text-align: left;
`;
